import { PersonaType } from '@/modules/auth/domain/models/Persona'
import { PersonaInfoSummary } from '@/therapist/pages/tasks/types/Task'

import { axios, Response } from '../index'

export interface GroupUsersByFeedGroup {
  id: number
  name: string
  personaType: PersonaType
}

const listGroupUserProfiles = (
  groupId: string
): Response<PersonaInfoSummary[]> => {
  return axios.get(`/v1/users/profiles/${groupId}`)
}

export default listGroupUserProfiles
